module.exports = __webpack_public_path__ + "img/icon-banner.a6459eff.png";